import { render, staticRenderFns } from "./Wistia.vue?vue&type=template&id=74ad0a58&scoped=true"
import script from "./Wistia.vue?vue&type=script&lang=js"
export * from "./Wistia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ad0a58",
  null
  
)

export default component.exports